import React from 'react';

import { GridDivider } from '@sharedComponents/Separators';
import { ReactFCV } from '@types';
import { DIVIDER_COLOR, DIVIDER_HEIGHT } from '@utils/constants';

import { IDiscount, IProduct } from '../../../../model';
import { useDiscountList } from '../../hooks';
import { DiscountItem } from '../DiscountItem';

import { StyledDiscountWrapper } from './styled';

interface IDiscountListItemProps {
  discounts: IDiscount[];
  products: IProduct[];
  whiteList?: number[];
  isDualPriceLayout: boolean;
}

export const DiscountList: ReactFCV<IDiscountListItemProps> = ({
  discounts,
  products,
  whiteList,
  isDualPriceLayout,
}) => {
  const discountsList = useDiscountList(discounts, products, whiteList);
  return (
    <StyledDiscountWrapper>
      {discountsList.map((discount) => (
        <React.Fragment key={discount.key}>
          <GridDivider color={DIVIDER_COLOR} height={DIVIDER_HEIGHT} />
          <DiscountItem {...discount} isDualPriceLayout={isDualPriceLayout} />
        </React.Fragment>
      ))}
    </StyledDiscountWrapper>
  );
};
